import React from 'react';

import { connect } from 'react-redux';
import activityActions from '../../redux/futures/activity/actions';
import _ from 'lodash';
import appConst from '../../config/const';
import Pagination from "react-js-pagination";
import baseHelper from '../../helpers/BaseHelper';
import * as types from '../../redux/futures/activity/types';
import LoadingScene from '../../components/LoadingScene';
import BlockUrl from '../tools/BlockUrl';
import BlockDomain from '../tools/BlockDomain';
import BlockPublish from '../tools/BlockPublish';
import BlacklistDomain from '../tools/BlackListDomain';
import CustomDatePicker from "../../components/DatePicker/CustomDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingTable from '../../components/LoadingTable';
import DetailResult from './components/DetailResult';



class LadiPageContentAudit extends React.Component {

    constructor(props) {
        super(props);
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.state = {
            activePage: 1,
            email: "",
            fromDate: firstDay,
            toDate: new Date(),
            searchType: {
                name: appConst.AUDIT_LEVEL.HIGH.name,
                value: appConst.AUDIT_LEVEL.HIGH.value,
                selected: appConst.AUDIT_LEVEL.HIGH,
            },
            item: {
                summary: '',
                report: '',
            },
            blockUrl: '',
            selectedLimit: appConst.PAGINATION.LIMIT_OPTIONS[1].value,
            excelDatas: [],
            // downloadUrl: '',
            submitData: false
        }

        this.selectedActivityIds = [];
        this.muteActions = [];
    }

    componentDidMount() {
        this.list();


    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {


        if (nextProps.action == types.LADIPAGE_CONTENT_AUDIT_LIST) {
            setTimeout(() => {
                this.setState({
                    items: nextProps.items
                });
            }, 200);
            if (nextProps.status) {

                // this.setState({
                //     downloadUrl: nextProps.url
                // });
            }
        }
    }

    /**
     * list store
     */
    list = (resetActivePageFlag = true) => {

        document.getElementById("checkAllItem").checked = false;
        window.LadiUI.forEach(window.LadiUI.querySelector(".ladiui.checkbox"), function (e) {
            e.checked = false;
        });


        const { selectedLimit, email, searchType } = this.state;
        // if (email == '') {
        //     window.LadiUI.toastr('error', '', 'Store id ko thể rỗng');
        //     return;
        // }
        let { fromDate, toDate } = this.state;
        let { activePage } = this.state;
        if (resetActivePageFlag) {
            activePage = 1;

            this.setState({
                activePage: 1,
            });
        }
        fromDate.setHours(0, 0, 0, 0);

        toDate.setHours(23, 59, 59, 999);

        const data = {
            "limit": selectedLimit,
            "offset": (activePage - 1) * selectedLimit,
            "from_date": fromDate,
            "to_date": toDate,
            "email": email,
            "overall_risk": searchType.selected.value,
        };

        if (searchType.selected.value == appConst.AUDIT_LEVEL.ALL.value) {
            delete data.overall_risk;
        }

        this.props.ladipageContentAuditList(data);
    }

    /*******************************SEARCH***************************/
    onChangeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    /**
     * Tim kiem theo name
     */
    onKeyDownInput = (event) => {
        if (event.key === 'Enter') {
            this.list();
        }
    }


    /****************************************************************/

    /*******************************PAGINATION***************************/
    /**
     * Change limit
     */
    onChangeLimit = (option) => {
        this.setState({ selectedLimit: option.value }, () => {
            this.list();
        })
    }

    /**
     * Change page
     */
    onPageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, () => {
            this.list(false);
        });
    }
    /****************************************************************/

    openCreateForm = () => {
        this.setState({
            mode: appConst.FORM_MODE.CREATE
        })
    }


    /*******************************CHECK AND ACTIONS***************************/
    checkAllItem = (event) => {
        const { checked } = event.target;

        this.selectedActivityIds = [];
        if (checked) {
            this.selectedActivityIds = _.map(this.props.activities, store => store._id);

            window.LadiUI.forEach(window.LadiUI.querySelector(".ladiui.checkbox"), function (e) {
                e.checked = true;
            });
        } else {
            window.LadiUI.forEach(window.LadiUI.querySelector(".ladiui.checkbox"), function (e) {
                e.checked = false;
            });
        }
    }

    checkItem = (event, activityId) => {
        const { checked } = event.target;
        const { selectedActivityIds } = this;

        if (checked) {
            if (!_.includes(selectedActivityIds, activityId)) {
                selectedActivityIds.push(activityId);
            }

            if (selectedActivityIds.length == this.props.activities.length) {
                document.getElementById("checkAllItem").checked = true;
            }
        } else {
            document.getElementById("checkAllItem").checked = false;
            _.remove(selectedActivityIds, selectedActivityId => selectedActivityId == activityId);
        }


    }

    sort = (event) => {
        const { classList } = event.target;
        const name = event.target.getAttribute('name');
        // Change arrow up and down
        if (_.includes(classList, 'up')) {
            classList.remove('up');
            this.sortBy[name] = 'ASC';
        } else {
            classList.add('up');
            this.sortBy[name] = 'DESC';
        }

        this.setState({
        }, () => this.list());
    }


    changeFromdate = (date) => {
        this.setState({
            fromDate: date
        }, () => {
            this.list();
        });

    }

    changeTodate = (date) => {
        this.setState({
            toDate: date
        }, () => {
            this.list();
        });

    }

    /****************************************************************/

    onChangeSearchAuditLevel = (option) => {
        this.setState({
            searchType: { ...this.state.searchType, selected: option },
        }, () => {
            this.list();
        })
    }

    openBlockUrl = (url) => {
        console.log('openBlockUrl :', url);
        this.setState({
            blockUrl: url,
        }, () => {
            window.LadiUI.showModalById('modal-block-url');
        })
    }
    openBlockDomain = (domain) => {
        console.log('openBlockDomain :', domain);
        this.setState({
            blockUrl: domain,
        }, () => {
            window.LadiUI.showModalById('modal-block-domain');
        })
    }
    openBlacklistDomain = (domain) => {
        console.log('openBlacklistDomain :', domain);
        this.setState({
            blockUrl: domain,
        }, () => {
            window.LadiUI.showModalById('modal-blacklist-domain');
        })
    }
    openBlockPublish = (domain) => {
        console.log('openBlockPublish :', domain);
        this.setState({
            blockUrl: domain,
        }, () => {
            window.LadiUI.showModalById('modal-block-publish');
        })
    }

    showDetailResult = (item) => {
        // console.log(store.store_id);
        this.setState({
            item: item,
        }, () => {
            window.LadiUI.showModalById('modal-detail-result');
        })

    };
    render() {

        const { totalRecord, totalPage } = this.props;
        const { activePage, selectedLimit, email, searchType, blockUrl } = this.state;
        let fromItem = 0;
        let toItem = 0;
        if ((this.props.items || []).length > 0) {
            fromItem = (activePage - 1) * selectedLimit + 1;
            toItem = fromItem + this.props.items.length - 1;
        }

        const msgShowItem = `Show ${fromItem} to ${toItem} of ${baseHelper.formatNumber(totalRecord)} items`;
        const isLoadingData = this.props.loading && (this.props.waitting == types.LADIPAGE_CONTENT_AUDIT_LIST);
        return (
            <div>
                <h1 className="page-title">Lịch sử duyệt nội dung LadiPage</h1>

                <div>
                    <div className="ladiui-table-actions">


                        <div className="action-item">
                            <div className="ladiui search-keyword">
                                <input type="text" id="email" placeholder="Search email" name="email" value={email} onChange={this.onChangeInput} onKeyDown={this.onKeyDownInput} className="ladiui input" />
                                <i className="ladi-icon icon-zoom" onClick={this.list} />
                            </div>
                        </div>
                        <div className="action-item">
                            <CustomDatePicker
                                customClass="ladiui input"
                                selected={this.state.fromDate}
                                onSelect={this.handleSelect} //when day is clicked
                                onChange={this.changeFromdate} //only when value has changed
                            />
                        </div>
                        <div className="action-item">

                        </div>
                        <div className="action-item">
                            <CustomDatePicker
                                customClass="ladiui input"
                                selected={this.state.toDate}
                                onSelect={this.handleSelect} //when day is clicked
                                onChange={this.changeTodate} //only when value has changed
                            />
                        </div>
                        <div className="action-item">
                            <div className="ladiui data-status">
                                <div className="ladiui-select-options" style={{ minWidth: '150px' }}>
                                    <span className="ladiui-select-init">{searchType.name}</span>
                                    <input type="hidden" name="select" defaultValue />
                                    <ul>
                                        {
                                            _.map(appConst.AUDIT_LEVEL, option =>
                                                <li key={option.value} className="select-item" onClick={() => this.onChangeSearchAuditLevel(option)}><a data-value={option.value}>{option.name}</a></li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        isLoadingData
                            ?
                            <LoadingTable />
                            :
                            <div>

                                <div className="ladi-card">

                                    <table className="ladiui table">
                                        <thead>
                                            <tr>
                                                <th className="ladiui checkall text-center">
                                                    <input id="checkAllItem" onClick={this.checkAllItem} type="checkbox" className="ladiui checkbox ladiui-checkall" />
                                                </th>
                                                {/* <th name="store_id" onClick={this.sort} className="text-left sorting">ID</th> */}
                                                <th className="text-left">Ladipage ID</th>
                                                <th className="text-left">Agent model</th>
                                                <th className="text-left">Danh mục</th>
                                                <th className="text-left">Phân loại</th>
                                                <th className="text-left">Mức độ cảnh báo</th>
                                                <th className="text-left">Đường dẫn trang</th>
                                                <th className="text-left">Loại trang</th>
                                                <th className="text-left">Tóm tắt</th>
                                                <th className="text-left">Chi phí input/output</th>
                                                <th className="text-left">Ngày duyệt</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                _.map(this.props.items, item => {

                                                    return <tr key={item._id}>
                                                        <td className="text-center">
                                                            <input type="checkbox" onClick={(event) => this.checkItem(event, item._id)} className="ladiui checkbox" />
                                                        </td>
                                                        <td>{item.ladipage_id}</td>
                                                        <td>{item.model_used}</td>
                                                        <td>{item.category}</td>
                                                        <td>{item.sub_category}</td>
                                                        <td><span className={`${item.overall_risk == 'high' ? 'text-danger' : item.overall_risk == 'medium' ? 'text-warning' : 'text-success'}`}>{item.overall_risk == 'high' ? 'Cao' : item.overall_risk == 'medium' ? 'Trung bình' : 'Thấp'}</span></td>
                                                        <td><a href={`https://${item.page_url}`} target="_blank">{item.page_url}</a></td>
                                                        <td>{item.view_type == 'Desktop' ? 'Desktop' : 'Mobile'}</td>
                                                        <td>{item.summary.slice(0, 100)}...
                                                            <i className="ladi-icon icon-c-question" onClick={() => this.showDetailResult(item)}></i>
                                                        </td>
                                                        <td>{item.usage ? item.usage.total_tokens : 0} ({item.usage ? item.usage.input_tokens : 0} + {item.usage ? item.usage.output_tokens : 0})</td>
                                                        <td>{baseHelper.formatStrToDate(item.last_audit_at)}</td>
                                                        <td>
                                                            <ul className="ladiui-navbar -horizontal row-actions">
                                                                <li className="ladiui-dropdown">
                                                                    <a><i className="ladi-icon icon-dots"></i></a>
                                                                    <ul>
                                                                        <li>
                                                                            <a onClick={() => this.openBlockUrl(item.page_url)}  >Chặn đường dẫn</a>
                                                                            <a onClick={() => this.openBlockDomain(item.page_url)}  >Block domain</a>
                                                                            <a onClick={() => this.openBlacklistDomain(item.page_url)}  >Blacklist link xuất bản</a>
                                                                            {/* <a onClick={() => this.openBlockPublish(item.page_url)}  >Chặn xuất bản</a> */}
                                                                            {/* <button className="ladiui button primary open-modal" modal="modal-block-url" onClick={this.openBlockUrl}>Chặn đường dẫn</button> */}
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                }
                                                )
                                            }
                                            {
                                                totalRecord <= 0 &&
                                                <tr className="text-center">
                                                    <td colSpan="100%">Không có bản ghi nào</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    }
                    {
                        totalRecord > 0 &&
                        <div className="ladiui pagination-block">
                            <div className="ladiui search-actions">
                                <div className="ladiui form-filter">
                                    <div className="ladiui data-limit">
                                        <span>Show</span>
                                        <div className="ladiui per-page">
                                            <div className="ladiui-select-options">
                                                <span className="ladiui-select-init">{selectedLimit}</span>
                                                <input type="hidden" name="select" defaultValue />
                                                <ul>
                                                    {
                                                        _.map(appConst.PAGINATION.LIMIT_OPTIONS, option =>
                                                            <li key={option.value} className="select-item" onClick={() => this.onChangeLimit(option)}><a href="#" data-value={option.value}>{option.name}</a></li>
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ladiui showing">{msgShowItem}</div>
                                </div>
                            </div>
                            {
                                totalRecord > 0 && <div className="ladiui pagination">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={selectedLimit}
                                        totalItemsCount={totalRecord}
                                        pageRangeDisplayed={5}
                                        onChange={this.onPageChange}
                                        prevPageText={<i className="ladi-icon icon-left-arrow" />}
                                        nextPageText={<i className="ladi-icon icon-right-arrow" />}
                                        firstPageText={<i className="ladi-icon icon-double-arrow-left" />}
                                        lastPageText={<i className="ladi-icon icon-double-arrow-right" />}
                                    />
                                </div>
                            }

                        </div>
                    }
                </div>
                <BlockUrl url={blockUrl} />
                <BlockDomain url={blockUrl} />
                <BlacklistDomain url={blockUrl} />
                <BlockPublish url={blockUrl} />
                {
                    this.state.loadingScene &&
                    <LoadingScene />
                }
                <DetailResult
                    item={this.state.item}
                />
                <input
                    readOnly
                    type="text"
                    className="ladiui input"
                    value={this.state.result}
                    ref={(textarea) => this.textAreaRef = textarea}
                    style={{
                        position: "absolute",
                        left: "-9999px"
                    }}
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ladipageContentAuditList: (data) => dispatch(activityActions.ladipageContentAuditList(data)),
    }
}

const mapStateToProps = (state) => ({ ...state.activity });

export default connect(mapStateToProps, mapDispatchToProps)(LadiPageContentAudit);